// extracted by mini-css-extract-plugin
var _1 = "default__Cfrnu";
var _2 = "bodyBold__O4pen";
var _3 = "bodySmall__kRCzo";
var _4 = "bold__fZzfG";
var _5 = "caption__gDFks";
var _6 = "h1__lYp7y";
var _7 = "h3__bembC";
var _8 = "label__KmbQr";
var _9 = "regular__CxQQh";
var _a = "semiBold__hOV2y";
var _b = "title__IuNlT";
var _c = "titleMobile__XiSsZ";
var _d = "value__UGfpc";
export { _1 as "_default", _2 as "bodyBold", _3 as "bodySmall", _4 as "bold", _5 as "caption", _6 as "h1", _7 as "h3", _8 as "label", _9 as "regular", _a as "semiBold", _b as "title", _c as "titleMobile", _d as "value" }
export default { "_default": _1, "bodyBold": _2, "bodySmall": _3, "bold": _4, "caption": _5, "h1": _6, "h3": _7, "label": _8, "regular": _9, "semiBold": _a, "title": _b, "titleMobile": _c, "value": _d }
